// This file is auto-generated by scripts/generate-models.ts
// Do not edit manually - run 'npm run generate-models' to update

import values from "./data/xai.json" with { type: "json" };
import { flattenModelCatalog, type ModelCatalog } from "../model-catalog.ts";

export const XAI_MODELS: ModelCatalog<typeof values, "xai"> =
	flattenModelCatalog("xai", values);
